import React, {useEffect, useState} from "react";
import Dialog from "../../base/dialog";
import {DialogTitle, Divider} from "@mui/material";
import SubmitTicketSection from "./sections/submit-ticket";
import ConfirmationSection from "./sections/confirmation";


const SubmitTicketDialog = ({
                                open,
                                close,
                                data,
                            }) => {
    const [successData, setSuccessData] = useState(null);

    /**
     * With each change in open state of the dialog:
     * - if not open, then resets the success data of the dialog.
     */
    useEffect(() => {
        if (!open) {
            setSuccessData(null)
        }
    }, [open])

    return (
        <>
            <Dialog
                open={open}
                setOpen={() => close(false)}
                maxWidth={'sm'}
                classes={{
                    root: 'submit-ticket-dialog-root'
                }}
                className={'bound-dialog submit-ticket-dialog'}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id={'scroll-dialog-title'}>
                    <p className={`text-lg text-color-1 my-3 font-weight-bold text-center`}>
                        {
                            successData
                                ? "Ticket Submitted"
                                : "Submit a Ticket"
                        }
                    </p>
                    <Divider className='divider'/>
                </DialogTitle>
                {
                    successData
                        ? <ConfirmationSection
                            data={successData}
                        />
                        : <SubmitTicketSection
                            data={data}
                            onSuccess={setSuccessData}
                        />
                }
            </Dialog>
        </>
    )
}


export default SubmitTicketDialog;
